/**
 * @module FE-CU10_ユーザ警備操作画面
 */
import Header from '../../../../components/header/Header.vue';
import MobileFooter from '../../../../components/footer/MobileFooter.vue';
import BreadCrumbList from '../../../../components/breadCrumb/List.vue';
import ListPanel from '../../../../components/listPanel/ListPanel.vue';
import SecuritySwitch from '../../../../components/securitySwitch/SecuritySwitch.vue';
import PcPageTitle from '../../../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import Paginate from 'vuejs-paginate';
import CONSTANTS from '../../../../constants';

const PAGE_ID = 'FE-CU10';

export default {
  name: 'UserSecurityControl',
  components: {
    Header,
    MobileFooter,
    BreadCrumbList,
    ListPanel,
    SecuritySwitch,
    PcPageTitle,
    PCFooter,
    Paginate,
  },
  data(vm) {
    return {
      page: 0,
      pageLength: 0,
      areaSelectDialog: false,
      title: vm.$vuetify.lang.t('$vuetify.FECU10ユーザー警備操作画面.ユーザー警備操作'),
      panelTitle: {
        place: '',
        type: '$vuetify.FECU10ユーザー警備操作画面.対象地区詳細.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [],
      lastSecurityDatetime: '',
      displayLastSecurityDatetime: '',
      lastOperator: '',
      warningOccurred: '',
      isAlert: false,
      lockUp: '',
      isLockUp: false,
      securityStatus: '',
      security01Image: require('../../../../assets/images/icon/security01.png'),
      doorlock01Image: require('../../../../assets/images/icon/doorlock01.png'),
      athome01Image: require('../../../../assets/images/icon/athome01.png'),
      securityFlag: false,
      warningCheck: false,
      lockUpCheck: false,
      targetAtHomeSetting: false,
      successAppCo9915: false,
      districtSplitName: '',
      displayDistrictNickname: '',
      securityAreaList: [],
      dontSelectFlag: false,
      securitySwitchReset: false,
      securitySelfPlanFlag: false,
      ///--------画面モック用一時対応---------
      door: false,
      kitchen: false,
      living: false,
      bed: false,
      balcony: false,
      totalVisiblePageItem: 3,
      securityUnitExecutionResults: [],
      CONSTANTS: CONSTANTS,
      width: 0,
      tabNumber: 0,
      absenceSwitch: false,
      athomeSwitch: false,
      listRow: 0,
      securityOperation: false,
      isShow: false,
      existsSecurityAreaList: [],
      existsSecurityArea: false,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU10ユーザー警備操作画面.ユーザー警備操作'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.C0001'),
      };
    },
    selectedSecurityArea() {
      return this.securityAreaList.some((area) => {
        return !!area.isMonitoringTargetAtHome;
      });
    },
    existsSecurity() {
      return this.securityOperation && this.existsSecurityArea ? true : false;
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期処理
     */
    async init() {
      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/userSecurityOperation/init';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        isSendCommand: true,
      };
      let method = 'post';
      let apiData = await this.APP_CU1001(param, queries, method);

      this.$store.commit('requestApi/setInterruptionFlag', false);
      if (typeof apiData.contentsInfo !== 'undefined') {
        let promiseList = [];
        this.securityUnitExecutionResults = [];
        // 警備状態送信コマンドキー
        let securityParams = {
          token: queries.token,
          terminalInfo: queries.terminalInfo,
          sendCustomerNumber: apiData.contentsInfo.unitCommandInfo[0].sendCustomerNumber,
          sendCommandKey: apiData.contentsInfo.unitCommandInfo[0].sendCommandKey,
          // sendCommandKey: '8036cd65-228a-4830-a916-e2c024559db8',
          apiId: 3, // 本画面では3
          alarmType: 0, // 入力必須ではないため0で埋める
          districtSplitNumber: '', // 入力必須ではないため""で埋める
          securityAreaId: '', // 入力必須ではないため""で埋める
        };

        // APP_CO9915
        promiseList.push(this.APP_CO9915_Security(securityParams));

        // 戸締り確認送信コマンドキー
        let lockUpParams = {
          token: queries.token,
          terminalInfo: queries.terminalInfo,
          sendCustomerNumber: apiData.contentsInfo.unitCommandInfo[1].sendCustomerNumber,
          sendCommandKey: apiData.contentsInfo.unitCommandInfo[1].sendCommandKey,
          // sendCommandKey: '8036cd65-228a-4830-a916-e2c024559db8',
          apiId: 3, // 本画面では3
          alarmType: 0, // 入力必須ではないため0で埋める
          districtSplitNumber: '', // 入力必須ではないため""で埋める
          securityAreaId: '', // 入力必須ではないため""で埋める
        };
        // APP_CO9915
        promiseList.push(this.APP_CO9915_LockUp(lockUpParams));

        await Promise.all(promiseList).then((values) => {
          this.warningCheck = apiData.contentsInfo.screenDisplayInfo.warningCheck;
          this.lockUpCheck = apiData.contentsInfo.screenDisplayInfo.lockUpCheck;
          this.targetAtHomeSetting = apiData.contentsInfo.screenDisplayInfo.targetAtHomeSetting;
          if (
            values.every((value) => value.contentsInfo.securityUnitExecutionResult !== -1) &&
            this.securityOperation
          ) {
            this.successAppCo9915 = true;
          }
        });

        if (this.$store.getters[`requestApi/getInterruptionFlag`]) {
          if (this.securityUnitExecutionResults.length != 0) {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            this.$_securityUnitExecutionResultsDialog(this.securityUnitExecutionResults);
          } else {
            this.$store.commit('requestApi/setInterruptionFlag', false);
            // エラーダイアログ(FE-CU10-E0002)を表示する。
            this.$_securityUnitExecutionResultDialog(-1);
          }
        }
      }

      this.setPagenationTabIndex();
    },
    /**
     * 初期表示(APP_CU1001)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1001: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 1,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     screenDisplayInfo: {
            //       warningCheck: true,
            //       lockUpCheck: true,
            //       targetAtHomeSetting: true,
            //     },
            //     unitCommandInfo: [
            //       {
            //         sendCustomerNumber: "sendCustomerNumber",
            //         sendCommandKey: "sendCommandKey",
            //       },
            //     ],
            //   },
            // };
            this.panelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU10ユーザー警備操作画面.対象地区詳細.対象地区',
              typeIsBefore: true,
            };

            this.displayDistrictNickname =
              apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname;

            this.securityOperation = apiData.contentsInfo.screenDisplayInfo.securityOperation;

            const targetItem = apiData.contentsInfo.displayDistrictInfo;

            // ------- データ整形 ---------
            const labels = {
              usagePlan: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.警備先名',
              districtSplitNumber: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.地区名',
              displayDistrictNickname:
                '$vuetify.FECU45救急情報設定画面.対象地区詳細表示領域.ニックネーム対象地区',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
              'displayDistrictNickname',
            ];

            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };

            Object.keys(targetItem).map((key) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU10ユーザー警備操作画面.メイン地区';
                  }
                  if (targetItem[key] === '') {
                    return;
                  }
                }
                this.displayAreaList = [
                  ...this.displayAreaList,
                  {
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });

            let displayDistrict = apiData.contentsInfo.displayDistrictInfo;
            let area = displayDistrict.customerNumber + displayDistrict.districtSplitNumber;
            if (
              [...this.existsSecurityAreaList].filter(() =>
                this.existsSecurityAreaList.includes(area)
              ).length > 0
            ) {
              this.existsSecurityArea = true;
            }

            if (
              displayDistrict.usagePlan != CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN
            ) {
              this.dontSelectFlag = true;
            }

            if (
              displayDistrict.usagePlan ==
                CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN ||
              displayDistrict.usagePlan ==
                CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE
            ) {
              // セルフ契約の場合
              this.securitySelfPlanFlag = true;
            }
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU1001に対する警備状態読み出しの警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} queries リクエストのパラメータ
     */
    APP_CO9915_Security: async function (params) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1001: {
          //         forSecurityStatus: {
          //           lastSecurityDatetime: '2021/11/17(水)20:00',
          //           lastOperator: '総警 花子',
          //           securityStatus: 'M',
          //         },
          //       },
          //     },
          //   },
          // };

          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            this.lastSecurityDatetime =
              apiData.contentsInfo.commandExecutionResult.app_cu1001.forSecurityStatus.lastSecurityDatetime;
            this.changeDayOfWeek();

            this.lastOperator =
              apiData.contentsInfo.commandExecutionResult.app_cu1001.forSecurityStatus.lastOperator;

            if (this.securityOperation) {
              const securityStatus =
                apiData.contentsInfo.commandExecutionResult.app_cu1001.forSecurityStatus
                  .securityStatus;
              // 警備状態を設定する
              switch (securityStatus) {
                case 'N':
                  this.securityStatus =
                    '$vuetify.FECU09対象地区詳細画面.警備状態データ.外出ALSOK警備中';
                  this.securityFlag = true;
                  break;
                case 'M':
                  this.securityStatus =
                    '$vuetify.FECU09対象地区詳細画面.警備状態データ.在宅ALSOK警備中';
                  this.securityFlag = true;
                  break;
                case 'S':
                  this.securityStatus =
                    '$vuetify.FECU09対象地区詳細画面.警備状態データ.外出セルフ警備中';
                  this.securityFlag = true;
                  break;
                case 'L':
                  this.securityStatus =
                    '$vuetify.FECU09対象地区詳細画面.警備状態データ.在宅セルフ警備中';
                  this.securityFlag = true;
                  break;
                case 'F':
                  this.securityStatus = '$vuetify.FECU09対象地区詳細画面.警備状態データ.警備解除中';
                  this.securityFlag = false;
                  break;
                case 'P':
                  this.securityStatus =
                    '$vuetify.FECU09対象地区詳細画面.警備状態データ.ユーザ点検中';
                  this.securityFlag = false;
                  break;
              }

              // 警備操作設定領域
              if (
                securityStatus === 'N' || // 外出 ALSOK 警備中
                securityStatus === 'M' || // 在宅 ALSOK 警備中
                securityStatus === 'S' || // 外出セルフ警備中
                securityStatus === 'L' // 在宅セルフ警備中
              ) {
                // 警備中の場合、「警備解除」を選択
                this.tabNumber = 2;
                this.securitySwitchReset = !this.securitySwitchReset;
              } else if (this.securitySelfPlanFlag) {
                // セルフ契約の場合、「外出セルフ」を選択
                this.tabNumber = 0;
                this.absenceSwitch = false;
                this.athomeSwitch = false;
                this.securitySwitchReset = !this.securitySwitchReset;
              } else {
                // 上記以外の場合、「外出ALSOK」を選択
                this.tabNumber = 0;
                this.absenceSwitch = true;
                this.athomeSwitch = true;
                this.securitySwitchReset = !this.securitySwitchReset;
              }

              // オンライン監視プラン以外のプランを選択中の場合セルフに固定
              if (this.dontSelectFlag) {
                this.absenceSwitch = false;
                this.athomeSwitch = false;
              }
            }
          } else if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (apiData.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });

      return apiData;
    },
    /**
     * APP_CU1001に対する戸締り確認読み出しの警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} queries リクエストのパラメータ
     */
    APP_CO9915_LockUp: async function (params) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1001: {
          //         forLockUp: {
          //           warningOccurredFlg: true,
          //           lockUpFlg: true,
          //         },
          //       },
          //     },
          //   },
          // };
          if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult == 0
          ) {
            if (
              apiData.contentsInfo.commandExecutionResult.app_cu1001.forLockUp.warningOccurredFlg
            ) {
              this.warningOccurred = '$vuetify.FECU10ユーザー警備操作画面.警報データ.異常あり';
              this.isAlert = true;
            } else {
              this.warningOccurred = '$vuetify.FECU10ユーザー警備操作画面.警報データ.異常なし';
              this.isAlert = false;
            }
            if (apiData.contentsInfo.commandExecutionResult.app_cu1001.forLockUp.lockUpFlg) {
              this.lockUp = '$vuetify.FECU10ユーザー警備操作画面.戸締り状態データ.異常あり';
              this.isLockUp = true;
            } else {
              this.lockUp = '$vuetify.FECU10ユーザー警備操作画面.戸締り状態データ.異常なし';
              this.isLockUp = false;
            }
          } else if (
            typeof apiData.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            apiData.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (apiData.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });

      return apiData;
    },
    /**
     * 警備設定(APP_CU1002)
     * @param {*} securityStatus 警備状態
     * @returns レスポンス
     */
    APP_CU1002: async function (securityStatus) {
      // 正常系を確認したい場合は下記のコメントを解除する
      let param = '/api/userSecurityOperation/securitySettings';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        securityStatus: securityStatus,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
          },
          (error) => {
            this.$_setLoadingAlsok(false);
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        );

      return apiData;
    },
    /**
     * APP_CU1002に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @param {*} securityStatus 警備状態
     * @returns レスポンス
     */
    APP_CU1002_CO9915: async function (params, securityStatus) {
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1002: {
          //         securityStatusChangeResult: 4
          //       }
          //     }
          //   },
          // };

          this.$_setLoadingAlsok(false);

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            if (
              typeof apiData.contentsInfo.commandExecutionResult.app_cu1002
                .securityStatusChangeResult !== 'undefined'
            ) {
              switch (
                apiData.contentsInfo.commandExecutionResult.app_cu1002.securityStatusChangeResult
              ) {
                case 0:
                  // 1. 警備状態変更コマンド実行結果 === 0: OKの場合
                  this.callSaveMessageDialog(
                    '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.C0007'
                  );
                  break;
                case 4:
                  // 2. 警備状態変更コマンド実行結果 === 4:操作禁止（遷移不可操作）の場合
                  if (securityStatus == 'F') {
                    this.callSaveMessageDialog(
                      '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.E0007'
                    );
                  } else {
                    this.callSaveMessageDialog(
                      '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.E0009'
                    );
                  }
                  break;
                case 3:
                  // 3. 警備状態変更コマンド実行結果 === 3: SFRエラーの場合
                  this.callSaveMessageDialog(
                    '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.E0008'
                  );
                  break;
                default:
                  // 4.1. 2. 3. 以外の場合
                  this.callSaveMessageDialog(
                    '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.E0001'
                  );
                  break;
              }
            }
          } else {
            // 2) 警備ユニット実行結果 !== 0: OKの場合
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        });

      return apiData;
    },
    /**
     * 警備エリア・在宅対象情報取得(APP_CO9910)
     * @returns レスポンス
     */
    APP_CU9910: async function () {
      this.$_setLoading(true);

      let param = '/api/common/getSecurityArea';
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
      };
      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CO9910に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9910_CO9915: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_co9910: {
          //         securityAreaList: [
          //           {
          //             securityAreaId: '1',
          //             securityAreaName: '玄関',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '2',
          //             securityAreaName: 'キッチン',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '3',
          //             securityAreaName: 'リビング',
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: '4',
          //             securityAreaName: '寝室',
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: '5',
          //             securityAreaName: 'ベランダ',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '6',
          //             securityAreaName: '子供部屋',
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: '7',
          //             securityAreaName: '書斎',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '8',
          //             securityAreaName: '倉庫',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '9',
          //             securityAreaName: '庭',
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: '10',
          //             securityAreaName: '車庫',
          //             isMonitoringTargetAtHome: false,
          //           },
          //           {
          //             securityAreaId: '11',
          //             securityAreaName: '屋根裏',
          //             isMonitoringTargetAtHome: true,
          //           },
          //           {
          //             securityAreaId: '12',
          //             securityAreaName: '廊下',
          //             isMonitoringTargetAtHome: false,
          //           },
          //         ],
          //       },
          //     },
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            this.securityAreaList =
              apiData.contentsInfo.commandExecutionResult.app_co9910.securityAreaList;
            this.page = 1;
            this.pageLength = Math.floor((this.securityAreaList.length - 1) / this.listRow) + 1;

            // 在宅対象エリアダイアログを表示
            this.areaSelectDialog = true;
            setTimeout(() => {
              this.setPagenationTabIndex();
            }, 50);
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 在宅対象情報更新(APP_CO9911)
     * @returns レスポンス
     */
    APP_CU9911: async function () {
      this.$_setLoading(true);

      let param = '/api/common/updateMonitoringTargetsAtHome';

      let securityAreaList = [];
      this.securityAreaList.forEach(function (securityArea) {
        securityAreaList.push({
          securityAreaId: securityArea.securityAreaId,
          isMonitoringTargetAtHome: securityArea.isMonitoringTargetAtHome,
        });
      });

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        securityAreaList: securityAreaList,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CO9911に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9911_CO9915: async function (params) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            if (apiData.contentsInfo.commandExecutionResult.app_co9911.requestResult == 0) {
              this.callInformationDialog(
                '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.C0008'
              );
            } else {
              // エラーメッセージ(FE-CU10-E0005)を表示する。
              this.callErrorDialog('$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.E0005');
            }
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備状態変更確認ダイアログ表示
     * @param {*} securityStatus 警備状態
     */
    async callSaveAgreementDialog(securityStatus) {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU10ユーザー警備操作画面.C0006',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // はいを押すと更新処理実行
        this.$_setLoadingAlsok(true, securityStatus);

        let apiData = await this.APP_CU1002(securityStatus);

        if (typeof apiData.contentsInfo !== 'undefined') {
          let params = {
            token: sessionStorage.getItem('token'),
            terminalInfo: localStorage.getItem('terminalInfo')
              ? localStorage.getItem('terminalInfo')
              : '',
            sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
            sendCommandKey: apiData.contentsInfo.sendCommandKey,
            apiId: 4,
            alarmType: 0,
            districtSplitNumber: this.$store.state.districtSplitNumber,
            securityAreaId: '',
          };
          // APP_CO9915
          await this.APP_CU1002_CO9915(params, securityStatus);
        }
      }
    },
    /**
     * 在宅対象情報更新完了ダイアログ表示
     * @param {*} text 完了メッセージ
     */
    callInformationDialog: async function (text) {
      await this.$informationDialog(text);

      // OK
      this.areaSelectDialog = false;
    },
    /**
     * 在宅対象情報更新エラーダイアログ表示
     * @param {*} text エラーメッセージ
     */
    callErrorDialog: async function (text) {
      await this.$errorDialog(text);

      // OK
      this.areaSelectDialog = false;
    },
    /**
     * 警備状態変更完了ダイアログ表示
     * @param {*} text 完了メッセージ
     */
    callSaveMessageDialog: async function (text) {
      this.$informationDialog(text);

      // OK
      this.areaSelectDialog = false;
      this.displayAreaList = [];
      this.init();
    },
    /**
     * 在宅警備対象チェックボックス押下処理(在宅対象設定ダイアログ)
     * @param {*} i 警備エリアリストインデックス番号
     */
    setFlag: function (i) {
      this.securityAreaList[i].isMonitoringTargetAtHome =
        !this.securityAreaList[i].isMonitoringTargetAtHome;
    },
    /**
     * クリアボタン押下処理(在宅対象設定ダイアログ)
     */
    clickClearButton: function () {
      this.securityAreaList.forEach(function (securityArea) {
        securityArea.isMonitoringTargetAtHome = false;
      });
    },
    /**
     * 全て選択ボタン押下処理(在宅対象設定ダイアログ)
     */
    clickAllSelect: function () {
      this.securityAreaList.forEach(function (securityArea) {
        securityArea.isMonitoringTargetAtHome = true;
      });
    },
    /**
     * 警備エリアリストインデックス番号取得処理
     * @param {*} i 在宅対象設定ダイアログに現在表示されている上から何番目かの数値
     * @returns 警備エリアリストインデックス番号
     */
    getSecurityAreaIndex: function (i) {
      return i - 1 + this.listRow * (this.page - 1);
    },
    /**
     * 在宅対象設定ダイアログ表示
     */
    openRemoteTagetDialog: async function () {
      let ret9910 = await this.APP_CU9910();

      if (typeof ret9910.contentsInfo !== 'undefined') {
        let params = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          sendCustomerNumber: ret9910.contentsInfo.sendCustomerNumber,
          sendCommandKey: ret9910.contentsInfo.sendCommandKey,
          apiId: 18, // 本画面では18を指定
          alarmType: 0, // 必須ではないので0で埋める
          districtSplitNumber: this.$store.state.districtSplitNumber, //APP_CO9910の場合のみ必須
          securityAreaId: '', // 必須ではないので""で埋める
        };
        // APP_CO9915
        await this.APP_CO9910_CO9915(params);
      }
    },
    /**
     * 適用ボタン押下処理(在宅対象設定ダイアログ)
     */
    clickOkButton: async function () {
      // 在宅対象設定ボタン押下時
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.設定された内容で登録します',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === false) return; // はい押下時のみ、処理を続行

      let ret9911 = await this.APP_CU9911();

      if (typeof ret9911.contentsInfo !== 'undefined') {
        let params = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          sendCustomerNumber: ret9911.contentsInfo.sendCustomerNumber,
          sendCommandKey: ret9911.contentsInfo.sendCommandKey,
          apiId: 19, // 本画面では19を指定
          alarmType: 0, // 必須ではないため0で埋める
          districtSplitNumber: '', // 必須ではないため""で埋める
          securityAreaId: '', // 必須ではないため""で埋める
        };
        // APP_CO9915
        await this.APP_CO9911_CO9915(params);
      }
    },
    /**
     * ページ変更処理(在宅対象設定ダイアログ)
     * @param {*} page ページ番号
     */
    changePage(page) {
      if (page === 1) {
        this.totalVisiblePageItem = 3;
      } else if (page >= 2 && page <= 6) {
        // show next 5 page when page is from 2 to 6
        this.totalVisiblePageItem = page + 5;
      } else if (page >= this.pageCount - 5 && page <= this.pageCount) {
        // show prev 5 page when page is from max-5 to max
        this.totalVisiblePageItem = this.pageCount + 6 - page;
      } else {
        this.totalVisiblePageItem = 11;
      }
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * 横幅変更処理
     * @param {*} width 横幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * 曜日文字列表示更新処理
     */
    changeDayOfWeek() {
      const date = this.lastSecurityDatetime.slice(0, -5);
      const time = this.lastSecurityDatetime.replace(date, '');
      const dayOfTheWeek = new Date(date).getDay();

      switch (dayOfTheWeek) {
        case CONSTANTS.DAY_OF_THE_WEEK.SUN:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.日') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.MON:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.月') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.TUE:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.火') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.WED:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.水') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.THU:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.木') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.FRI:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.金') + ') ' + time;
          break;
        case CONSTANTS.DAY_OF_THE_WEEK.SAT:
          this.displayLastSecurityDatetime =
            date + '(' + this.$vuetify.lang.t('$vuetify.コード.曜日.土') + ') ' + time;
          break;

        default:
          break;
      }
      this.displayLastSecurityDatetime = this.displayLastSecurityDatetime.replace(/-/g, '/');
    },
    /**
     * ページネーションのタブインデックス初期化処理
     */
    setPagenationTabIndex() {
      const elements = document.getElementsByClassName('page-number');
      for (let element of elements) {
        element.tabIndex = -1;
      }
    },
    /**
     * ユーザー権限一覧取得(APP_CU9916)
     */
    async APP_CO9916() {
      this.$_setLoading(true);
      let param = '/api/common/getRoleList';
      // let param = "post";

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
      };

      let method = 'post';
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(() => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

          if (typeof apiData.contentsInfo !== 'undefined') {
            // 侵入センサーがあるデータを配列にまとめる
            this.existsSecurityAreaList = [];
            apiData.contentsInfo.displayDistrictInfoList.forEach((displayDistrictInfo) => {
              if (
                displayDistrictInfo.existsSecurityArea &&
                displayDistrictInfo.userAuthority.securityOperation
              ) {
                this.existsSecurityAreaList.push(
                  displayDistrictInfo.customerNumber + displayDistrictInfo.districtSplitNumber
                );
              }
            });
          }
        })
        .catch((error) => {
          this.$_abnormality(error.response.status);
        })
        .finally(() => {
          this.$_setLoading(false);
        });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    if (this.$mq === 'pc') {
      this.listRow = 10;
    } else {
      this.listRow = 5;
    }

    this.width =
      this.$mq === 'pc' ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP;
    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });
    this.isShow = true;
    // 言語切り替え
    this.$watch('$vuetify.lang.current', function () {
      this.changeDayOfWeek();
    });

    if (this.$store.getters['isLoggedIn']) {
      await this.APP_CO9916();
    }

    this.init();
    //初期通信完了後に画面を表示
    this.isShowPage = true;
    // loadingDialogコンポーネントの呼び出し
    await this.$loadingDialog();

    // ToDo 「No.4を満たす場合、活性。」に関する処理を追加
    // 恐らく9916でセンサーの有無が取得できるようになる
  },
};
